import { useEffect, useState } from "react";
import { t } from "../i18n";
import { Link } from "react-router-dom";
import { Crown, ArrowUp, ArrowRight, ArrowDown } from "lucide-react";
import { api } from "../lib/api";
import { Shell } from "../components/Shell";
import { Avatar, Flag, RedFlagIcon } from "../components/Avatar";

export const Trend = ({ t: tr }) => tr === "sube" ? <ArrowUp size={16} className="text-emerald-400" data-testid="trend-sube" /> : tr === "baja" ? <ArrowDown size={16} className="text-[#f43f5e]" data-testid="trend-baja" /> : <ArrowRight size={16} className="text-muted-foreground" data-testid="trend-igual" />;

const Podium = ({ p, size, height }) => p ? (
  <Link to={`/personas/${p.id}`} data-testid={`podium-${p.posicion}`} className="flex flex-col items-center gap-2 flex-1">
    <Avatar nombre={p.nombre} src={p.foto_url} size={size} coronada={p.coronada} redFlag={p.red_flag} />
    <p className="text-sm font-medium flex items-center gap-1 text-center">{p.nombre} <Flag iso={p.pais_iso} size={14} />{p.red_flag && <RedFlagIcon size={13} testId={`podium-red-flag-${p.id}`} />}</p>
    <p className="text-xs text-[#f3c649] font-display">{p.score.toFixed(1)}</p>
    <div className={`w-full rounded-t-xl flex items-start justify-center pt-2 text-lg font-display ${p.posicion === 1 ? "bg-[#d4af37]/25 text-[#f3c649]" : "bg-secondary text-muted-foreground"}`} style={{ height }}>{p.posicion}</div>
  </Link>
) : <div className="flex-1" />;

export default function Ranking() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/ranking", { params: { limit: 10 } }).then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  const [p1, p2, p3, ...rest] = items || [];

  return (
    <Shell title={t("tabs.ranking")} fab={false}>
      {items === null && <p className="text-sm text-muted-foreground">{t("common.loading")}</p>}
      {items?.length === 0 && <div data-testid="ranking-empty" className="surface p-8 text-center text-sm text-muted-foreground mt-6">{t("ranking.empty")}</div>}
      {items?.length > 0 && (
        <div className="fade-up">
          <div className="flex items-end gap-2 mb-4" data-testid="podium">
            <Podium p={p2} size={64} height={56} />
            <Podium p={p1} size={88} height={84} />
            <Podium p={p3} size={64} height={40} />
          </div>
          <ul className="space-y-2" data-testid="ranking-list">
            {rest.map((p) => (
              <li key={p.id}><Link to={`/personas/${p.id}`} data-testid={`rank-${p.posicion}`} className="surface p-3 flex items-center gap-3">
                <span className="w-6 text-center font-display text-muted-foreground">{p.posicion}</span>
                <Avatar nombre={p.nombre} src={p.foto_url} size={40} coronada={p.coronada} redFlag={p.red_flag} />
                <div className="flex-1 min-w-0"><p className="text-sm font-medium flex items-center gap-2 truncate">{p.nombre} <Flag iso={p.pais_iso} size={14} /> {p.coronada && <Crown size={13} className="text-[#d4af37]" fill="#d4af37" />}{p.red_flag && <RedFlagIcon size={13} testId={`rank-red-flag-${p.id}`} />}</p>
                  {p.apodo && <p className="text-xs text-muted-foreground">"{p.apodo}"</p>}</div>
                <span className="text-sm font-display text-[#f3c649]">{p.score.toFixed(1)}</span>
                <Trend t={p.score_tendencia} />
              </Link></li>
            ))}
          </ul>
          <p className="text-xs text-center text-muted-foreground mt-6 flex items-center justify-center gap-1"><Crown size={12} className="text-[#d4af37]" /> {t("ranking.crownNote")}</p>
        </div>
      )}
    </Shell>
  );
}
